module.exports = __webpack_public_path__ + "static/img/dsvgx.db1872e5.png";